import { ChevronRightIcon } from '@heroicons/react/24/outline'
import dayjs from 'dayjs'

import { InviteWithStatus } from '@/api/models/users/lib/invites.types'
import { maskPhoneNumber } from '@/utils/maskPhoneNumber'

import { InviteStatus } from '..'

type Props = {
  invite: InviteWithStatus
  onClick: () => void
}

export const InviteCard = ({ invite, onClick }: Props) => (
  <button
    className="flex h-[128px] w-full items-start justify-start gap-8 rounded-12 !bg-white px-16 py-20"
    onClick={onClick}
  >
    <div className="flex w-full flex-col">
      <div className="flex justify-between">
        <p className="font-bold text-20 sm:text-18">
          {maskPhoneNumber(invite?.phone)}
        </p>
        <ChevronRightIcon className="h-24 w-24 text-grey-50" />
      </div>
      {invite?.customName && (
        <p className="text-left text-bronze-40 text-16">{invite.customName}</p>
      )}
      <div className="flex items-end justify-between">
        <InviteStatus
          name={invite.statusName}
          color={invite.statusColor}
          iconUrl={invite.statusIconUrl}
        />
        <p className="text-16">
          {dayjs(invite.invitedAt).isToday()
            ? 'Сегодня'
            : dayjs(invite.invitedAt).format('D MMMM')}
        </p>
      </div>
    </div>
  </button>
)
